/**
 * Get's the current component value based on the amount of inputs filled.
 *
 * @param valueMap - The current value of the component
 * @param digits - The amount of digits in the code.
 */
function getValue(valueMap, digits) {
    const value = Array.from(valueMap.values()).join('');
    return value.slice(0, digits);
}
export { getValue, };
//# sourceMappingURL=digit-inputs-utils.js.map